export const categories = [
  {
    id: 'nurse-photoshoot',
    name: '护士主题写真',
    slug: 'nurse-photoshoot',
    description: '专业医护主题写真拍摄，融合性感与专业的视觉大片，为你打造独一无二的护士形象。从清纯白衣天使到魅惑夜班护士，多种风格任你选择。',
    icon: 'ri-camera-lens-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20fashion%20photography%20studio%20with%20soft%20warm%20lighting%2C%20medical%20nurse%20themed%20photo%20shoot%20setting%20with%20elegant%20white%20and%20pink%20aesthetic%2C%20clean%20minimal%20background%2C%20editorial%20style%2C%20high%20end%20fashion%20magazine%20quality&width=800&height=600&seq=cat-nurse-photo-001&orientation=landscape',
    items: [
      {
        id: 1,
        title: '白衣天使系列',
        description: '清纯优雅的经典护士造型，白大褂与柔美光影的完美结合',
        price: '¥1,299起',
        image: 'https://readdy.ai/api/search-image?query=Elegant%20white%20nurse%20uniform%20fashion%20photography%2C%20soft%20natural%20light%2C%20clean%20cream%20background%2C%20editorial%20portrait%20style%2C%20delicate%20and%20pure%20aesthetic&width=600&height=800&seq=item-angel-001&orientation=portrait',
        tag: '热门',
      },
      {
        id: 2,
        title: '夜班魅影系列',
        description: '暗调光影下的性感护士造型，红色高跟鞋与听诊器的魅惑组合',
        price: '¥1,599起',
        image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20nurse%20themed%20fashion%20portrait%2C%20dramatic%20lighting%2C%20red%20stilettos%2C%20stethoscope%20accessory%2C%20sensual%20yet%20professional%20vibe%2C%20cinematic%20photography%20style&width=600&height=800&seq=item-night-002&orientation=portrait',
        tag: '新品',
      },
      {
        id: 3,
        title: '手术室风云系列',
        description: '手术服变时尚利器，冷色调下的高级感写真',
        price: '¥1,899起',
        image: 'https://readdy.ai/api/search-image?query=Cool%20toned%20surgical%20themed%20fashion%20photography%2C%20scrub%20uniform%20styled%20as%20high%20fashion%2C%20clean%20minimal%20studio%20lighting%2C%20editorial%20magazine%20quality%2C%20professional%20yet%20stylish&width=600&height=800&seq=item-surgery-003&orientation=portrait',
        tag: '',
      },
      {
        id: 4,
        title: '粉红护士系列',
        description: '甜美粉色系护士造型，少女感与专业性并存',
        price: '¥1,399起',
        image: 'https://readdy.ai/api/search-image?query=Soft%20pink%20nurse%20uniform%20fashion%20photography%2C%20sweet%20and%20feminine%20aesthetic%2C%20pastel%20studio%20background%2C%20gentle%20lighting%2C%20kawaii%20elegant%20style%2C%20professional%20portrait&width=600&height=800&seq=item-pink-004&orientation=portrait',
        tag: '',
      },
    ],
  },
  {
    id: 'cosplay-costume',
    name: '角色扮演服装',
    slug: 'cosplay-costume',
    description: '高品质护士角色扮演服装定制，从经典护士服到创意比基尼护士装，精选面料、精细剪裁，让你在漫展、派对中脱颖而出。',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=High%20quality%20nurse%20cosplay%20costumes%20displayed%20on%20mannequins%2C%20various%20styles%20from%20classic%20to%20creative%20bikini%20nurse%20designs%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20textile%20details%20visible&width=800&height=600&seq=cat-cosplay-002&orientation=landscape',
    items: [
      {
        id: 5,
        title: '经典护士服套装',
        description: '传统修身护士连衣裙，精选弹力棉面料，舒适贴身',
        price: '¥399',
        image: 'https://readdy.ai/api/search-image?query=Classic%20white%20nurse%20dress%20uniform%20costume%2C%20fitted%20silhouette%2C%20clean%20product%20photography%20on%20white%20background%2C%20professional%20tailoring%20details%2C%20cotton%20fabric%20texture%20visible&width=600&height=800&seq=costume-classic-005&orientation=portrait',
        tag: '经典款',
      },
      {
        id: 6,
        title: '比基尼护士装',
        description: '大胆创意的比基尼式护士服，医用十字标志与泳装元素融合',
        price: '¥299',
        image: 'https://readdy.ai/api/search-image?query=Creative%20bikini%20nurse%20costume%20design%2C%20medical%20cross%20logo%20detail%2C%20red%20and%20white%20color%20scheme%2C%20fashion%20product%20photography%2C%20clean%20studio%20lighting%2C%20swimwear%20and%20uniform%20fusion&width=600&height=800&seq=costume-bikini-006&orientation=portrait',
        tag: '爆款',
      },
      {
        id: 7,
        title: '漆皮护士制服',
        description: '亮面漆皮材质护士服，前卫时尚的派对必备款',
        price: '¥459',
        image: 'https://readdy.ai/api/search-image?query=Patent%20leather%20nurse%20uniform%20costume%2C%20glossy%20finish%2C%20avant%20garde%20fashion%20design%2C%20studio%20product%20photography%2C%20dark%20background%20contrast%2C%20high%20fashion%20cosplay&width=600&height=800&seq=costume-patent-007&orientation=portrait',
        tag: '',
      },
      {
        id: 8,
        title: '护士内衣套装',
        description: '医用主题情趣内衣，蕾丝与绷带元素的创意碰撞',
        price: '¥259',
        image: 'https://readdy.ai/api/search-image?query=Elegant%20medical%20themed%20lingerie%20set%2C%20lace%20details%20with%20bandage%20design%20elements%2C%20soft%20romantic%20lighting%2C%20boudoir%20product%20photography%2C%20delicate%20fabric%20texture&width=600&height=800&seq=costume-lingerie-008&orientation=portrait',
        tag: '',
      },
    ],
  },
  {
    id: 'body-care',
    name: '美体护理',
    slug: 'body-care',
    description: '专业级美体护理服务，融合医护标准的科学护肤理念。从全身SPA到局部塑形，我们以严谨的医护态度呵护你的每一寸肌肤。',
    icon: 'ri-heart-pulse-line',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20spa%20treatment%20room%20with%20medical%20grade%20equipment%2C%20warm%20soft%20lighting%2C%20clean%20white%20towels%20and%20products%2C%20professional%20aesthetic%2C%20serene%20atmosphere%2C%20high%20end%20wellness%20center&width=800&height=600&seq=cat-bodycare-003&orientation=landscape',
    items: [
      {
        id: 9,
        title: '全身精油SPA',
        description: '医用级精油配合专业手法，深层放松每一块肌肉',
        price: '¥688/次',
        image: 'https://readdy.ai/api/search-image?query=Luxury%20aromatherapy%20massage%20setup%2C%20essential%20oils%20bottles%20on%20white%20towel%2C%20warm%20candlelight%20ambiance%2C%20spa%20product%20photography%2C%20serene%20and%20clean%20aesthetic&width=600&height=800&seq=care-spa-009&orientation=portrait',
        tag: '推荐',
      },
      {
        id: 10,
        title: '医用级面部护理',
        description: '采用医美级产品，针对不同肤质定制护理方案',
        price: '¥528/次',
        image: 'https://readdy.ai/api/search-image?query=Professional%20medical%20grade%20facial%20treatment%20products%2C%20skincare%20serums%20and%20tools%2C%20clean%20white%20aesthetic%2C%20clinical%20yet%20luxurious%20setting%2C%20dermatology%20clinic%20photography&width=600&height=800&seq=care-facial-010&orientation=portrait',
        tag: '',
      },
      {
        id: 11,
        title: '身体塑形管理',
        description: '非侵入式身体塑形，科技与手法结合的完美体验',
        price: '¥988/次',
        image: 'https://readdy.ai/api/search-image?query=Modern%20body%20contouring%20treatment%20room%2C%20advanced%20aesthetic%20equipment%2C%20clean%20white%20clinical%20interior%2C%20professional%20wellness%20center%2C%20warm%20indirect%20lighting&width=600&height=800&seq=care-slimming-011&orientation=portrait',
        tag: '',
      },
      {
        id: 12,
        title: '孕产修复护理',
        description: '产后妈妈专属修复方案，科学温和的恢复护理',
        price: '¥788/次',
        image: 'https://readdy.ai/api/search-image?query=Gentle%20postnatal%20care%20treatment%20setting%2C%20soft%20pink%20and%20white%20aesthetic%2C%20comforting%20atmosphere%2C%20professional%20wellness%20environment%2C%20warm%20natural%20light%2C%20mother%20care%20concept&width=600&height=800&seq=care-postnatal-012&orientation=portrait',
        tag: '',
      },
    ],
  },
];